export const CAPITAL_FEDERAL = 1;
